import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { GcConnectionComponent } from './component/gc-connection.component';

@NgModule({
  declarations: [
    GcConnectionComponent
  ],
  imports: [
    CommonModule,
    QRCodeComponent
  ]
})
export class GcConnectionModule { }
